// Internal modules
import { apolloClient } from '@/lib/apollo';
import { redirectToGenericError } from '@/lib';
import { FETCH_PHONE_METADATA_QUERY } from '../queries/fetchPhoneMetadata.gql';
import { mapPhoneMetadata } from '../../utils';
import type {
  CountryCodes,
  FetchPhoneMetadataQueryQuery,
  FetchPhoneMetadataQueryQueryVariables,
} from '@/generated/graphql';
import type { PhoneMetaData } from '../../types';

export const fetchPhoneMetadata = (
  countryCode: CountryCodes,
): Promise<void | PhoneMetaData> => {
  return apolloClient
    .query<FetchPhoneMetadataQueryQuery, FetchPhoneMetadataQueryQueryVariables>(
      {
        query: FETCH_PHONE_METADATA_QUERY,
        variables: { countryCode },
      },
    )
    .then(({ data }) => {
      return mapPhoneMetadata(data);
    })
    .catch(error => {
      redirectToGenericError(error);
    });
};
